import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Notificacao } from '../../../../shared/interfaces/notificacao';
import { AppConfirmService } from '../../../../shared/services/app-confirm/app-confirm.service';
import { JwtAuthService } from '../../../../shared/services/auth/jwt-auth.service';
import { NotificacaoService } from '../../../../shared/services/notificacao.service';
import * as DOMPurify from 'dompurify';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-notification-detail',
  templateUrl: './notification-detail.component.html',
  styleUrls: ['./notification-detail.component.scss']
})
export class NotificationDetailComponent implements OnInit {

  notificacao: Notificacao;
  safeTexto: SafeHtml | null = null;
  technicalDetails: any = null;

  constructor( 
    @Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<NotificationDetailComponent>,
  private authService: JwtAuthService,
  private route: ActivatedRoute,
  private router: Router,
  private confirmService: AppConfirmService,
  private notificacaoService: NotificacaoService,
  private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.notificacao = this.data.payload;
    this.safeTexto = this._sanitizeHtml(this.notificacao?.texto);
    
    // Parse technical details from outrosDados
    if (this.notificacao?.outrosDados) {
      try {
        this.technicalDetails = JSON.parse(this.notificacao.outrosDados);
      } catch (e) {
        console.warn('Could not parse technical details:', e);
        this.technicalDetails = null;
      }
    }
  }

  close() {
    this.dialogRef.close();
   
  }

  private _sanitizeHtml(html?: string): SafeHtml | null {
    if (!html) return null;
    // normaliza default / named export do dompurify
    const purifier: any = (DOMPurify as any).default ? (DOMPurify as any).default : DOMPurify;
    const clean = purifier.sanitize(html, {
      ALLOWED_TAGS: ['b','i','em','strong','u','p','br','ul','ol','li','a','span','div','img','h1','h2','h3','h4','table','thead','tbody','tr','td','th','section','style'],
      ALLOWED_ATTR: ['href','src','alt','title','target','rel','class','style','cellpadding','cellspacing','border']
    });
    return this.sanitizer.bypassSecurityTrustHtml(clean);
  }

}
